import type { PartyKind, PartyStanding } from "@ravnar/api-contract";

import type { Tone } from "../components/ui/tone";

/**
 * Vocabulary of the Directory page. What a party is, and where it stands today, come from the API contract, which the
 * API validates its answers with; the tones and the colours only this page shows live here.
 */
export {
	DIRECTORY_QUERY_MAX_LENGTH,
	PARTY_KIND_LABELS,
	PARTY_KINDS,
	partyStatus,
	type DirectoryEntry,
	type PartyKind,
} from "@ravnar/api-contract";

/**
 * The tone of a standing's pill: a live relationship is settled, one that has not started is news, one that is over
 * is past, and a record somebody still has to finish is a warning.
 */
export const PARTY_STANDING_TONES: Readonly<Record<PartyStanding, Tone>> = {
	active: "ok",
	upcoming: "info",
	past: "neutral",
	incomplete: "warn",
};

/**
 * Dot colour per kind, reusing the section hues rather than a token of its own. Full class names, never built from
 * strings, so Tailwind can find them — the rule `SECTION_DOT_CLASS` follows.
 */
export const PARTY_KIND_DOT_CLASS: Readonly<Record<PartyKind, string>> = {
	person: "bg-people",
	vendor: "bg-finance",
	customer: "bg-equity",
	other: "bg-ink-4",
};

/**
 * What each kind of record is for, in a line: the Add party drawer's picker shows it under the kind's name, and the New
 * menu under the command that adds one.
 */
export const PARTY_KIND_BLURBS: Readonly<Record<PartyKind, string>> = {
	person: "Someone the business employs or contracts. Kept in People & HR.",
	vendor: "A supplier the business buys from.",
	customer: "Someone the business sells to, or is hoping to.",
	other: "A bank, an insurer, an investor — anyone who does not fit the other three.",
};
